import { motion } from 'framer-motion';
import CompleteImg from '@/assets/img/learning_complete.png';

export default function LearningComplete() {
  return (
    <section className='flex flex-col gap-5 justify-center items-center px-5 pt-10 pb-5'>

      {/* 글자: 먼저 천천히 등장 */}
      <motion.h1
        className='text-3xl font-bold text-center'
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.6, ease: 'easeOut' }}
      >
        우와~ 유닛 다 끝냈다! <br /> 최고 최고~!
      </motion.h1>

      {/* 이미지: 글자 끝난 후 팍 등장 */}
      <motion.img
  src={CompleteImg}
  alt=""
  className="max-w-[300px]"
  initial={{ scale: 0.1,  rotate: -10 }}
  animate={{
    scale: [0.8, 1.1, 1],
    rotate: [-10, 0],
  }}
  transition={{
    duration: 0.6,
    ease: 'easeOut',
    times: [0, 0.5, 1]
  }}
/>
    </section>
  );
}